import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-flex mx-auto flex-column" }
const _hoisted_2 = { style: {"padding-top":"1px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.layout === 'tr' ? 'tr' : 'v-row'), {
    "no-gutters": "",
    class: _normalizeClass({
            'pa-0': _ctx.layout !== 'tr',
            'ma-0': _ctx.layout !== 'tr',
            'd-flex flex-column justify-center align-center': _ctx.layout !== 'tr',
        }),
    style: _normalizeStyle({ height: _ctx.layout !== 'tr' ? '100%' : '' })
  }, {
    default: _withCtx(() => [
      (_ctx.layout === 'vertical')
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            class: "px-1 my-2 w-100",
            style: {"background-color":"white","border-radius":"5px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                class: "pa-0 ma-0 border-e-sm",
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createElementVNode("small", { class: "d-inline-block" }, "Dossier de révision", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_progress_circular, {
                        rotate: -90,
                        size: 60,
                        width: 8,
                        color: _ctx.getProgressColor(_ctx.props.item.id),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAvatarClicked('auditReport'))),
                        style: {"cursor":"pointer"},
                        "model-value": _ctx.getAuditReportStatusPercent(_ctx.props.item.id)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getAuditReportStatus(_ctx.props.item.id)), 1)
                        ]),
                        _: 1
                      }, 8, ["color", "model-value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, {
                class: "pa-0 ma-0",
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createElementVNode("small", { class: "d-inline-block" }, "Liasse", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_avatar, {
                        tile: true,
                        size: "28",
                        color: _ctx.getBundleColor(_ctx.props.item),
                        onClick: _ctx.onLAvatarClicked,
                        style: {"cursor":"pointer"}
                      }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createElementVNode("span", { class: "text-white font-weight-bold" }, "L", -1)
                        ])),
                        _: 1
                      }, 8, ["color", "onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_ctx.layout === 'horizontal')
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              "no-gutters": "",
              class: "px-1 my-2 w-100",
              style: {"background-color":"white","border-radius":"5px","height":"auto"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "7",
                  class: "pa-0 ma-0",
                  style: {"border-right":"0.8px solid rgba(0, 0, 0, 0.12)"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      cols: "12",
                      class: "d-flex justify-center align-center"
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createElementVNode("small", { class: "d-inline-block" }, "Dossier de révision", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      cols: "12",
                      class: "d-flex justify-center align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_progress_circular, {
                          rotate: -90,
                          size: 55,
                          width: 6,
                          color: _ctx.getProgressColor(_ctx.props.item.id),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onAvatarClicked('auditReport'))),
                          style: {"cursor":"pointer"},
                          "model-value": _ctx.getAuditReportStatusPercent(_ctx.props.item.id)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getAuditReportStatus(_ctx.props.item.id)), 1)
                          ]),
                          _: 1
                        }, 8, ["color", "model-value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "5",
                  class: "pa-0 ma-0 d-flex align-center",
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        cols: "12"
                      }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createElementVNode("small", { class: "d-inline-block" }, "Liasse", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        cols: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_avatar, {
                            tile: true,
                            size: "28",
                            color: _ctx.getBundleColor(_ctx.props.item),
                            onClick: _ctx.onLAvatarClicked,
                            style: {"cursor":"pointer"}
                          }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createElementVNode("span", { class: "text-white font-weight-bold" }, "L", -1)
                            ])),
                            _: 1
                          }, 8, ["color", "onClick"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.headers, (header, index) => {
              return (_openBlock(), _createElementBlock("td", {
                key: index,
                style: {"padding":"0px"}
              }, [
                (index === 0 && !_ctx.hideName)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      "no-gutters": "",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onNameClicked(_ctx.props.item))),
                      style: {"cursor":"pointer"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "font-weight-medium pl-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.props.item.name), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (index === (_ctx.hideName ? 0 : 1))
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 1,
                        "no-gutters": "",
                        class: "rounded d-flex justify-center",
                        style: {"overflow":"hidden","cursor":"pointer"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "1" }),
                          _createVNode(_component_v_col, {
                            cols: "10",
                            class: "d-flex justify-center align-center"
                          }, {
                            default: _withCtx(() => [
                              (!_ctx.loading)
                                ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                                    key: 0,
                                    "data-cy": "AccountingClientMonitoring-audit",
                                    readonly: "",
                                    rounded: "",
                                    color: _ctx.getProgressColor(_ctx.props.item.id),
                                    height: "15",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onAvatarClicked('auditReport'))),
                                    "model-value": _ctx.getAuditReportStatusPercent(_ctx.props.item.id)
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("strong", _hoisted_2, _toDisplayString(_ctx.getAuditReportStatus(_ctx.props.item.id)), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["color", "model-value"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "1" })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_row, {
                        key: 2,
                        "no-gutters": "",
                        class: "rounded d-flex justify-center",
                        style: {"overflow":"hidden","cursor":"pointer"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "4" }),
                          _createVNode(_component_v_col, {
                            cols: "4",
                            class: "ma-0 d-flex justify-center"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives((_openBlock(), _createBlock(_component_v_avatar, {
                                tile: true,
                                color: _ctx.getBundleColor(_ctx.props.item),
                                size: "25",
                                class: "pa-0 ma-0 avatarHover",
                                onClick: _ctx.onLAvatarClicked,
                                style: {"cursor":"pointer"},
                                "data-cy": "AccountingClientMonitoring-case"
                              }, {
                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                  _createElementVNode("span", { class: "text-white font-weight-bold" }, "L", -1)
                                ])),
                                _: 1
                              }, 8, ["color", "onClick"])), [
                                [
                                  _directive_tooltip,
                                  _ctx.getBundleStatus(_ctx.props.item),
                                  void 0,
                                  { bottom: true }
                                ]
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "4" })
                        ]),
                        _: 1
                      }))
              ]))
            }), 128))
    ]),
    _: 1
  }, 8, ["class", "style"]))
}